import { render, staticRenderFns } from "./PromotionListTable.vue?vue&type=template&id=5e4f8a34"
import script from "./PromotionListTable.vue?vue&type=script&lang=js"
export * from "./PromotionListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports